/* Flechas del carrusel de "Cadena de valor" (sections/chain-of-value.liquid).
 *
 * Por que NO usa Flickity:
 * empire.js registra la seccion `dynamic-highlights-banner` y le monta Flickity,
 * pero SOLO por debajo del breakpoint M. Como el CSS de la seccion hace scroll
 * nativo (overflow-x + scroll-snap), en movil quedaban DOS sistemas de carrusel
 * peleando por el mismo elemento: Flickity reposiciona las tarjetas en absolute
 * dentro de un .flickity-viewport y el flex/gap/scroll-snap queda muerto.
 * Encima, el fix del bug de foco de Flickity (tt-flickity-focus-fix.js) apunta a
 * .featured-collection__content, o sea que aca ese bug seguia sin arreglar.
 * Se saco el registro de empire.js y quedo solo el scroll nativo, que ya era lo
 * que funcionaba en desktop. Mismo camino que ya habian tomado
 * list-col-swiper.liquid y featured-contacts.liquid.
 *
 * Este archivo solo agrega lo unico que el scroll nativo no da gratis: flechas
 * en desktop. Cero dependencias, cero jQuery, no toca empire.js.
 */
(function () {
  'use strict';

  if (window.__ttChainOfValue) return;
  window.__ttChainOfValue = true;

  function setup(wrap) {
    if (wrap.dataset.chainInit) return;
    wrap.dataset.chainInit = '1';

    var track = wrap.querySelector('[data-chain-track]');
    var prev = wrap.querySelector('[data-chain-prev]');
    var next = wrap.querySelector('[data-chain-next]');
    if (!track) return;

    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* Se cachea el ultimo estado y se agenda con requestAnimationFrame para no
       provocar "reflow forzado": leer scrollWidth obliga a recalcular el layout,
       y hacerlo en cada evento de scroll/resize (que se disparan decenas de veces
       seguidas) es justo lo que castiga el INP. Si el estado no cambio, NO se
       toca el DOM. */
    var last = null;
    var scheduled = false;

    function update() {
      scheduled = false;
      var scrollable = track.scrollWidth - track.clientWidth > 4;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      var state = scrollable + '|' + atStart + '|' + atEnd;
      if (state === last) return;
      last = state;

      if (prev) {
        prev.hidden = !scrollable || atStart;
        prev.disabled = prev.hidden;
      }
      if (next) {
        next.hidden = !scrollable || atEnd;
        next.disabled = next.hidden;
      }
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    }

    schedule();
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
  }

  function boot(root) {
    var wraps = (root || document).querySelectorAll('[data-chain-scroll]');
    for (var i = 0; i < wraps.length; i++) setup(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // El editor de temas re-renderiza la seccion sin recargar la pagina.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
